import { useRef, useEffect } from "react";
import * as echarts from "echarts";
import { useRequest, useSize } from "ahooks";
import { statistic as statisticService } from "@/services";

function MonthChart({ token }) {
  const chartRef = useRef();
  const chartNodeRef = useRef();
  const size = useSize(chartNodeRef);
  const { loading } = useRequest(
    () => statisticService.listAnnouncementMonth(),
    {
      ready: !!token,
      onSuccess: (res) => {
        const categories = res.map((r) => {
          const d = new Date(r.name);
          return d.getMonth() + 1;
        });
        const values = res.map((r, l) => {
          return res.reduce((acc, current, i) => {
            if (i <= l) {
              return acc + current.value;
            }
            return acc;
          }, 0);
        });
        if (chartRef && chartRef.current) {
          chartRef.current.setOption({
            title: {
              text: "逐月公告发布数量",
              left: "center",
            },
            tooltip: {
              trigger: "item",
            },
            legend: {
              orient: "vertical",
              left: "left",
            },
            xAxis: {
              type: "category",
              data: categories,
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                type: "line",
                data: values,
              },
            ],
          });
        }
      },
    }
  );
  useEffect(() => {
    const chartDom = chartNodeRef.current;
    if (!chartRef.current) {
      const c = echarts.init(chartDom);
      chartRef.current = c;
    }
    return () => {
      if (chartRef.current) chartRef.current.dispose();
    };
  }, [chartRef, chartNodeRef]);
  useEffect(() => {
    if (chartRef && !chartRef.current.isDisposed()) {
      chartRef.current.resize();
    }
  }, [chartRef, size]);
  return <div className="chart-wrapper" ref={chartNodeRef}></div>;
}

export default MonthChart;
